<!-- Sisse logitud kasutaja profiil -->
<template>
  <v-menu min-width="200px" rounded location="bottom">
    <template v-slot:activator="{ props }">
      <v-btn class="d-flex" icon variant="plain" v-bind="props">
        <v-icon size="40">mdi-account-circle</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-text>
        <div class="mx-auto text-center">
          <div class="d-flex align-center ga-3">
            <v-avatar color="eraklient">
              <v-icon>mdi-account-circle</v-icon>
            </v-avatar>
            <div class="text-left">
              <h3>{{ displayName }}</h3>
              <p class="user-email" v-if="user.email">{{ user.email }}</p>
            </div>
          </div>
          <v-divider class="my-3"></v-divider>
          <v-btn class="mb-2" color="eraklient" variant="outlined" rounded @click="openChangePasswordDialog">
            Muuda parooli
          </v-btn>
          <br>
          <v-btn class="mb-2" color="eraklient" variant="outlined" rounded @click="openEshopPopupDialog">
            E-poe popup
          </v-btn>
          <br>
          <v-btn color="error" rounded @click="Logout">Log out</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-menu>

  <v-dialog v-model="changePasswordDialog" width="auto" max-width="500" transition="none">
    <v-card min-width="360">
      <v-toolbar color="white" title="Muuda parooli">
        <v-btn icon="mdi-close" @click="closeChangePasswordDialog"></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-text-field
            v-model="currentPassword"
            type="password"
            label="Praegune parool"
            variant="outlined"
            autocomplete="current-password"
        ></v-text-field>
        <v-text-field
            v-model="newPassword"
            type="password"
            label="Uus parool"
            variant="outlined"
            autocomplete="new-password"
        ></v-text-field>
        <v-text-field
            v-model="confirmPassword"
            type="password"
            label="Korda uut parooli"
            variant="outlined"
            autocomplete="new-password"
        ></v-text-field>
        <p v-if="passwordError" class="password-error">{{ passwordError }}</p>
      </v-card-text>
      <v-divider></v-divider>
      <div class="ma-4 d-flex ga-3">
        <v-btn
            color="success"
            rounded
            :loading="isChangingPassword"
            :disabled="!canChangePassword"
            @click="changePassword"
        >
          Salvesta
        </v-btn>
        <v-btn rounded @click="closeChangePasswordDialog">Tühista</v-btn>
      </div>
    </v-card>
  </v-dialog>

  <v-dialog v-model="eshopPopupDialog" width="auto" max-width="600" transition="none">
    <v-card class="pa-4">
      <v-toolbar color="white" title="E-poe popup teade">
        <v-btn icon="mdi-close" @click="closeEshopPopupDialog"></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-file-input
            v-model="popupImageSelection"
            label="Lae taustapilt"
            variant="outlined"
            prepend-icon="mdi-camera"
            accept="image/*"
            :loading="isUploadingPopupImage"
            @update:modelValue="uploadPopupImage"
        ></v-file-input>
        <v-btn
            class="mb-4"
            color="eraklient"
            variant="outlined"
            :loading="loadingCloudinaryImages"
            @click="fetchCloudinaryImages"
        >
          Lae pildid
        </v-btn>
        <p v-if="cloudinaryError" class="password-error">{{ cloudinaryError }}</p>
        <div v-if="cloudinaryImages.length" class="cloudinary-gallery">
          <button
              v-for="image in cloudinaryImages"
              :key="image.public_id"
              type="button"
              class="cloudinary-item"
              :class="{ selected: eshopPopupImage === image.url }"
              @click="eshopPopupImage = image.url"
          >
            <img :src="image.url" :alt="image.public_id"/>
            <span
                class="cloudinary-delete"
                @click.stop.prevent="openDeleteCloudinaryDialog(image)"
            >
              <v-icon size="16">mdi-delete</v-icon>
            </span>
          </button>
        </div>
        
        <p v-if="eshopPopupError" class="password-error">{{ eshopPopupError }}</p>
        <tiptap v-model="eshopPopupText"></tiptap>
        <v-divider class="my-4"></v-divider>
        <div v-if="showEshopPopupPreview" class="eshop-popup-preview-container">
          <div class="eshop-popup-preview-header">Eelvaade:</div>
          <div class="eshop-popup-preview" :style="previewBackgroundStyle">
            <div class="eshop-popup-preview-overlay">
              <div class="eshop-popup-preview-text" v-html="eshopPopupText"></div>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <div class="ma-4 d-flex ga-3 flex-wrap">
        <v-btn
            color="success"
            rounded
            :loading="isSavingEshopPopup"
            @click="saveEshopPopup"
        >
          Salvesta
        </v-btn>
        <v-btn
            color="error"
            variant="outlined"
            rounded
            :loading="isDeletingEshopPopup"
            @click="deleteEshopPopup"
        >
          Kustuta popup
        </v-btn>
        <v-btn rounded @click="closeEshopPopupDialog">Tühista</v-btn>
      </div>
    </v-card>
  </v-dialog>

  <v-dialog v-model="deleteImageDialog" width="auto" transition="none">
    <v-card min-width="360">
      <v-toolbar color="white" title="Kinnitus">
        <v-btn icon="mdi-close" @click="closeDeleteCloudinaryDialog"></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-alert type="warning" variant="tonal" border="start" prominent>
          Kas oled kindel, et soovid selle pildi kustutada?
        </v-alert>
      </v-card-text>
      <v-divider></v-divider>
      <div class="ma-4">
        <v-btn
            class="text-none mr-4 font-weight-bold"
            color="error"
            min-width="92"
            rounded
            :loading="deletingPublicId === pendingDeleteImage?.public_id"
            @click="confirmDeleteCloudinaryImage"
        >
          Jah
        </v-btn>
        <v-btn class="text-none font-weight-bold" min-width="92" rounded @click="closeDeleteCloudinaryDialog">
          Ei
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {toast} from "vue3-toastify";
import Tiptap from "@/components/Tiptap";

export default {
  name: "UserProfile",
  components: { Tiptap },
  data: () => ({
    user: {},
    changePasswordDialog: false,
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
    passwordError: "",
    isChangingPassword: false,
    eshopPopupDialog: false,
    eshopPopupText: "",
    eshopPopupImage: "",
    popupImageSelection: null,
    eshopPopupError: "",
    isSavingEshopPopup: false,
    isDeletingEshopPopup: false,
    isUploadingPopupImage: false,
    loadingCloudinaryImages: false,
    cloudinaryError: "",
    cloudinaryImages: [],
    deletingPublicId: null,
    deleteImageDialog: false,
    pendingDeleteImage: null,
    showEshopPopupPreview: true,
  }),
  computed: {
    displayName() {
      const email = this.user?.email || "";
      if (!email) return "User";
      return email.split("@")[0] || email;
    },
    canChangePassword() {
      return (
          this.currentPassword.trim().length > 0 &&
          this.newPassword.trim().length >= 6 &&
          this.confirmPassword.trim().length >= 6
      );
    },
    previewBackgroundStyle() {
      if (!this.eshopPopupImage) {
        return {
          backgroundImage: `linear-gradient(135deg, #667eea 0%, #764ba2 100%)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        };
      }
      return {
        backgroundImage: `url('${this.eshopPopupImage}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      };
    },
  },
  methods: {
    fetchAUser() {
      fetch(`${process.env.VUE_APP_SERVER_URL}/auth/me`, {
        method: "GET",
        credentials: "include",
      })
          .then((response) => response.json())
          .then((data) => {
            this.user = data || {};
          })
          .catch((err) => console.log(err.message));
    },
    openChangePasswordDialog() {
      this.passwordError = "";
      this.changePasswordDialog = true;
    },
    async openEshopPopupDialog() {
      this.eshopPopupError = "";
      this.eshopPopupDialog = true;
      await this.fetchEshopPopupText();
      await this.fetchCloudinaryImages();
    },
    closeEshopPopupDialog() {
      this.eshopPopupDialog = false;
      this.eshopPopupError = "";
      this.isSavingEshopPopup = false;
      this.isDeletingEshopPopup = false;
      this.cloudinaryError = "";
    },
    async fetchCloudinaryImages() {
      this.loadingCloudinaryImages = true;
      this.cloudinaryError = "";
      try {
        const response = await fetch(`${process.env.VUE_APP_SERVER_URL}/api/uploads/images?t=${Date.now()}`, {
          method: "GET",
          credentials: "include",
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || "Failed to load Cloudinary images");
        this.cloudinaryImages = data;
      } catch (error) {
        this.cloudinaryError = "Cloudinary piltide laadimine ebaonnestus";
        console.log(error);
      } finally {
        this.loadingCloudinaryImages = false;
      }
    },
    openDeleteCloudinaryDialog(image) {
      this.pendingDeleteImage = image;
      this.deleteImageDialog = true;
    },
    closeDeleteCloudinaryDialog() {
      this.deleteImageDialog = false;
      this.pendingDeleteImage = null;
    },
    async confirmDeleteCloudinaryImage() {
      const image = this.pendingDeleteImage;
      if (!image?.public_id) return;

      this.cloudinaryError = "";
      this.deletingPublicId = image.public_id;

      try {
        const response = await fetch(`${process.env.VUE_APP_SERVER_URL}/api/uploads/image`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({ public_id: image.public_id }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || "Image delete failed");

        this.cloudinaryImages = this.cloudinaryImages.filter((item) => item.public_id !== image.public_id);
        if (this.eshopPopupImage === image.url) {
          this.eshopPopupImage = "";
        }
      } catch (error) {
        this.cloudinaryError = "Pildi kustutamine ebaonnestus";
        console.log(error);
      } finally {
        this.deletingPublicId = null;
        this.closeDeleteCloudinaryDialog();
      }
    },
    async fetchEshopPopupText() {
      try {
        const response = await fetch(`${process.env.VUE_APP_SERVER_URL}/api/texts/11`);
        if (response.status === 404) {
          this.eshopPopupText = "";
          this.eshopPopupImage = "";
          return;
        }

        const data = await response.json();
        this.eshopPopupText = (data?.body || "").toString();
        this.eshopPopupImage = this.parseTextImage(data?.image);
      } catch (e) {
        this.eshopPopupError = "Popup teksti laadimine ebaonnestus";
      }
    },
    parseTextImage(image) {
      if (!image) return "";

      if (Array.isArray(image)) {
        const first = image.find((value) => typeof value === "string" && value.trim() !== "");
        return first || "";
      }

      if (typeof image === "string") {
        const trimmed = image.trim();
        if (!trimmed) return "";

        if (trimmed.startsWith("{") && trimmed.endsWith("}")) {
          return trimmed
              .slice(1, -1)
              .split(",")
              .map((value) => value.replace(/^"|"$/g, "").trim())
              .find(Boolean) || "";
        }

        return trimmed;
      }

      return "";
    },
    async uploadPopupImage(fileInput) {
      const file = Array.isArray(fileInput) ? fileInput[0] : fileInput;
      if (!file) return;

      this.eshopPopupError = "";
      this.isUploadingPopupImage = true;

      try {
        const formData = new FormData();
        formData.append("image", file);

        const response = await fetch(`${process.env.VUE_APP_SERVER_URL}/api/uploads/image`, {
          method: "POST",
          body: formData,
          credentials: "include",
        });

        const data = await response.json();
        if (!response.ok) {
          throw new Error(data?.error || "Pildi üleslaadimine ebaonnestus");
        }

        this.eshopPopupImage = data.url;
        this.popupImageSelection = null;
      } catch (e) {
        this.eshopPopupError = e?.message || "Pildi üleslaadimine ebaonnestus";
      } finally {
        this.isUploadingPopupImage = false;
      }
    },
    removePopupImage() {
      this.eshopPopupImage = "";
      this.popupImageSelection = null;
    },
    async saveEshopPopup() {
      this.eshopPopupError = "";
      this.isSavingEshopPopup = true;

      try {
        const response = await fetch(`${process.env.VUE_APP_SERVER_URL}/api/texts/11`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            body: this.eshopPopupText,
            body_en: null,
            body_ru: null,
            image: this.eshopPopupImage ? [this.eshopPopupImage] : [],
          }),
        });

        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload?.error || "Popup salvestamine ebaonnestus");
        }

        toast.success("E-poe popup salvestatud");
        this.closeEshopPopupDialog();
      } catch (e) {
        this.eshopPopupError = e?.message || "Popup salvestamine ebaonnestus";
      } finally {
        this.isSavingEshopPopup = false;
      }
    },
    async deleteEshopPopup() {
      this.eshopPopupError = "";
      this.isDeletingEshopPopup = true;

      try {
        const response = await fetch(`${process.env.VUE_APP_SERVER_URL}/api/texts/11`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            body: "",
            body_en: null,
            body_ru: null,
            image: [],
          }),
        });

        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload?.error || "Popup kustutamine ebaonnestus");
        }

        this.eshopPopupText = "";
  this.eshopPopupImage = "";
        toast.success("E-poe popup kustutatud");
        this.closeEshopPopupDialog();
      } catch (e) {
        this.eshopPopupError = e?.message || "Popup kustutamine ebaonnestus";
      } finally {
        this.isDeletingEshopPopup = false;
      }
    },
    closeChangePasswordDialog() {
      this.changePasswordDialog = false;
      this.currentPassword = "";
      this.newPassword = "";
      this.confirmPassword = "";
      this.passwordError = "";
      this.isChangingPassword = false;
    },
    async changePassword() {
      this.passwordError = "";

      if (this.newPassword !== this.confirmPassword) {
        this.passwordError = "Uued paroolid ei kattu";
        return;
      }

      if (this.newPassword.length < 6) {
        this.passwordError = "Uus parool peab olema vahemalt 6 tahemarki";
        return;
      }

      this.isChangingPassword = true;
      try {
        const response = await fetch(`${process.env.VUE_APP_SERVER_URL}/auth/change-password`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            currentPassword: this.currentPassword,
            newPassword: this.newPassword,
          }),
        });

        const data = await response.json();
        if (!response.ok) {
          throw new Error(data?.error || "Parooli muutmine ebaonnestus");
        }

        toast.success("Parool muudetud");
        this.closeChangePasswordDialog();
      } catch (e) {
        this.passwordError = e?.message || "Parooli muutmine ebaonnestus";
      } finally {
        this.isChangingPassword = false;
      }
    },
    Logout() {
      fetch(`${process.env.VUE_APP_SERVER_URL}/auth/logout`, {
        credentials: 'include',
      })
          .then((response) => response.json())
          .then((data) => {
            console.log(data);
            console.log('jwt removed');
            this.$store.commit('SET_LOGIN_STATUS', false);
            toast.success("Logged out");
          })
          .catch((e) => {
            console.log(e);
            console.log("error logout");
          });
    }
  },
  mounted() {
      this.fetchAUser();
  }
}
</script>

<style scoped>
  .user-email {
    font-size: 0.85rem;
    color: #777;
    margin: 0;
  }

  .password-error {
    color: #b00020;
    margin: 0;
  }

  .popup-image-preview-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .popup-image-preview {
    width: 100%;
    max-height: 220px;
    object-fit: cover;
    border-radius: 10px;
    border: 1px solid #ddd;
  }

  .cloudinary-gallery {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 12px;
    margin-bottom: 20px;
  }

  .cloudinary-item {
    position: relative;
    border: 2px solid transparent;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    padding: 0;
    background: transparent;
  }

  .cloudinary-item.selected {
    border-color: #4caf50;
  }

  .cloudinary-item img {
    display: block;
    width: 100%;
    height: 120px;
    object-fit: cover;
  }

  .cloudinary-delete {
    position: absolute;
    top: 6px;
    right: 6px;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    color: #fff;
    background: rgba(176, 0, 32, 0.85);
  }

  .eshop-popup-preview-container {
    margin-top: 16px;
    padding: 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background-color: #f5f5f5;
  }

  .eshop-popup-preview-header {
    font-size: 12px;
    font-weight: 600;
    color: #666;
    margin-bottom: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .eshop-popup-preview {
    position: relative;
    min-height: 280px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 6px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .eshop-popup-preview-overlay {
    position: absolute;
    inset: 0;
    padding: 28px;
    background: rgba(14, 23, 41, 0.35);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .eshop-popup-preview-text {
    font-size: 17px;
    line-height: 1.6;
  }

  .eshop-popup-preview-text :deep(p) {
    margin: 0 0 10px 0;
  }

  .eshop-popup-preview-text :deep(*) {
    color: inherit;
  }

</style>